// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9N0uL","rootNoMargin":"styles_rootNoMargin__8scVd"};